import "core-js/modules/es.array.map.js";
import classnames from 'classnames';
import styles from "./CheckList.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var CheckList = function CheckList(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    checkListClassName = _ref.checkListClassName,
    minHeight = _ref.minHeight;
  return /*#__PURE__*/_jsx("div", {
    className: classnames('check-list', styles['check-list'], checkListClassName),
    style: {
      minHeight: minHeight
    },
    children: items && /*#__PURE__*/_jsx("ul", {
      children: items.map(function (item, idx) {
        return /*#__PURE__*/_jsx("li", {
          children: item
        }, idx);
      })
    })
  });
};